import { DestinationPlaceholder } from "@/routes/DestinationPlaceholder";

export function WorkOrders() {
  return <DestinationPlaceholder id="work-orders" />;
}
